module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEhSURBVHgB7ZE9TsMwFMefnQ9VKrGytaggeUSViMIN6MZYRjaOACcATsDKhhiZ4AaFEyQCBjYyFCkghigKUmjkmOe2Q1W5H0s3/yTL9vv6Pz8DGAyGjUN0Rm83+FB7VY16ZfqeLCvg+9wXW94tkZDkn6/n836qzapxSeCO4w6anW64sHh7jwuPRdhnX+LSxWgFLIceoMKjEqHEjlgnOJuP8bb3+8J2IxWD3ceVoD1tLZ2xzNJylH/fu6xFcIaHOMijBmvBX/71rPxsJ7gASm7w2ECBO+uXnhQ/caqrpf2DWZrYPSVwPbmpV9EMiDwd3wCuiuHL5bL8lQITkW5IwX7AaD41ZRLq42L49rQqdy0Bhd8OubDqgTqreZdpnIDBYFiLf07XUn1dMrS6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dropdown_arrow_down.png
// module id = 1644
// module chunks = 0